import axios from "axios";
import { baseUrl } from "../constants/Constant.js";
import { getLocalAuth } from "./AuthUtils.js";

const values = getLocalAuth()
const profile = JSON.parse(values.authLocal);

const client = axios.create({
    baseURL: baseUrl,
    headers: {
        "Content-Type": "application/json",
    },
});

client.interceptors.request.use(
    (config) => {
        if (profile) {
            config.headers["Authorization"] =
                profile !== null ? `Bearer ${profile.data.token}` : "";
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

client.interceptors.response.use(
    (res) => {
        return res;
    },
    async (err) => {
        const originalConfig = err.config;

        if (err.response) {
            // Access Token was expired
            if (err.response.status === 401 && !originalConfig._retry) {
                originalConfig._retry = true;

                if (err.response.status === 401) {
                    window.location =
                        window.location.protocol +
                        "//" +
                        window.location.host +
                        "/auth/login";
                }

                if (err.response && err.response.data) {
                    return Promise.reject(err.response.data);
                }

                return Promise.reject(err);
            }

            if (err.response.status === 403 && err.response.data) {
                return Promise.reject(err.response.data);
            }
        }

        return Promise.reject(err);
    }
);

export default client;
